import { createMultiStyleConfigHelpers, ThemingProps } from '@chakra-ui/react'
import { themeColorSectionKeys } from '~/themes/colors/colors'
import { Size } from '~/types/ThemeTypes'
import {
  createCustomStyleContext,
  useCustomMultiStyleConfig,
} from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

const { Icon } = themeColorSectionKeys.defaults
const { CloseButton } = themeColorSectionKeys.shared

export enum MangoCloseButtonVariant {
  Primary = 'primary',
  AlertWindow = 'alertWindow',
}
const mangoCloseButtonStyleparts = ['closeButton', 'closeButtonIcon']

const helpers = createMultiStyleConfigHelpers(mangoCloseButtonStyleparts)
export const MangoCloseButtonStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    closeButton: {
      display: 'flex',
      boxSize: '32px',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '50%',
      cursor: 'pointer',
      userSelect: 'none',
      ariaLabel: 'Close',
      backgroundColor: CloseButton.Primary.Background.Default,
      _hover: {
        backgroundColor: CloseButton.Primary.Background.Hover,
      },
      _active: {
        backgroundColor: CloseButton.Primary.Background.Active,
      },
    },
    closeButtonIcon: {
      color: Icon,
      boxSize: '16px',
    },
  },
  variants: {
    [MangoCloseButtonVariant.AlertWindow]: {
      closeButton: {
        backgroundColor: CloseButton.AlertWindow.Background.Default,
        _hover: {
          backgroundColor: CloseButton.AlertWindow.Background.Hover,
        },
        _active: {
          backgroundColor: CloseButton.AlertWindow.Background.Active,
        },
      },
      closeButtonIcon: {
        color: CloseButton.AlertWindow.Icon,
      },
    },
  },
  sizes: {
    [Size.sm]: {
      closeButton: {
        boxSize: '24px',
      },
      closeButtonIcon: {
        boxSize: '12px',
      },
    },
    [Size.md]: {
      closeButton: {
        boxSize: '32px',
      },
      closeButtonIcon: {
        boxSize: '16px',
      },
    },
  },
  defaultProps: {
    size: Size.md,
  },
})

const themeKey = getName({ MangoCloseButtonStyle })
export const useMangoCloseButtonStyles = (props?: ThemingProps) =>
  useCustomMultiStyleConfig<typeof mangoCloseButtonStyleparts>(themeKey, props)
export const createMangoCloseButtonStylesContext =
  createCustomStyleContext<typeof mangoCloseButtonStyleparts>(themeKey)
